module.exports = __webpack_public_path__ + "static/media/windmill_day.4eda8be5.JPG";